var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4H14.5C18.92 4 22.5 7.58 22.5 12C22.5 16.42 18.92 20 14.5 20H10.5C6.08 20 2.5 16.42 2.5 12C2.5 7.58 6.08 4 10.5 4Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16C16.7091 16 18.5 14.2091 18.5 12C18.5 9.79086 16.7091 8 14.5 8C12.2909 8 10.5 9.79086 10.5 12C10.5 14.2091 12.2909 16 14.5 16Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggle-icon.ed730e1202d703330e73c89d607cce9e.svg";
export { ForwardRef as ReactComponent };